import React, { useEffect, useState } from "react";
import blogData from "../../Data/blogData";
import { Link, useParams } from "react-router-dom";

const BlogDetails = () => {
  const { id } = useParams();

  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    setBlogs(blogData);
  }, []);

  const item = blogs.find((i) => i.id === Number(id));

  return (
    <div>
      <div
        className="breadcumb-wrapper"
        style={{
          backgroundImage: "url('/assets/image/clean7.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "350px", // or any desired height
          display: "flex",
          alignItems: "flex-end", // this pushes content to the bottom
          paddingBottom: "30px", // space from bottom edge
        }}
      >
        <div className="container mt-5">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">
              {item && item.title.slice(0, 15)}...
            </h1>
            <ul className="breadcumb-menu">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>BLOG DETAILS</li>
            </ul>
          </div>
        </div>
      </div>

      <section className="th-blog-wrapper blog-details space-top space-extra2-bottom">
        <div className="container">
          <div className="title-area text-center">
            <span className="sub-title6 justify-content-center">
              <span className="shape left">
                <span className="dots"></span>
              </span>
              BLOG DETAILS
              <span className="shape right">
                <span className="dots"></span>
              </span>
            </span>
          </div>

          <div className="row gx-30">
            <div className="col-xxl-12 col-lg-7">
              <div className="th-blog blog-single">
                <div className="blog-img">
                  <img src={item && item.image} alt="Blog Imagee" />
                </div>

                <div className="blog-content">
                  <div className="blog-meta">
                    <Link className="author" to="">
                      <i className="fa-solid fa-user"></i>
                      {item && item.author}
                    </Link>
                    <Link to="">
                      <i className="fa-solid fa-calendar-days"></i>
                      {item && item.date}
                    </Link>
                  </div>
                  <h2 className="blog-title">{item && item.title}</h2>
                  <p style={{ textAlign: "justify" }}>
                    {item && item.description}
                  </p>

                  <blockquote>
                    <p>{item && item.specialText}</p>
                    <cite>{item && item.author}</cite>
                  </blockquote>

                  <p style={{ textAlign: "justify" }} className="mt-30 mb-30">
                    {item && item.description2}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BlogDetails;
